import { Tooltip } from '@/components/tooltip';
import { AlertCircle } from 'lucide-react';

interface NoTimeZoneWarningProps {
  className?: string;
}

export function NoTimeZoneWarning({ className }: NoTimeZoneWarningProps) {
  return (
    <Tooltip trigger={<AlertCircle className={`h-4 w-4 text-amber-500 ${className ?? ''}`} />}>
      The school/district does not have a time zone. This class time displayed may be incorrect since we cannot
      interpret the time zone of the entered class time.
    </Tooltip>
  );
}
